import React, { useState, useEffect } from "react";
import { Modal, Button } from 'antd';
import { useTranslation } from "react-i18next";
import '../../layout/Modal.scss';
import './style.scss';
import { identity } from "../../utils/getIdentity";

const EditAutoswapModal = ({ visible, closeModal, name, confirmEdit }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsVisible(visible)
  }, [visible]);

  const handleCancel = e => {
    setIsVisible(false);
    closeModal();
  };

  return (
    <React.Fragment>
      <Modal
        width={275}
        visible={isVisible}
        onCancel={handleCancel}
        footer={null}
        className={`remove-autoswap remove-autoswap-${identity}`}
      >
        <div className="remove-autoswap-content">
          <div className={`modal-form__title modal-form__title-${identity}`}>{t('admin.edit')}</div>
          <div className={`modal-form__subtitle modal-form__subtitle-${identity}`}>{t('admin.want_to_edit')} “{name}”</div>
          <div className="modal-form__btnWrapper">
            <Button type="default" className={`form__button component__button remove-autoswap-btn remove-autoswap-btn-${identity}`} onClick={closeModal}>
              {t('admin.cancel')}
            </Button>
            <Button type="primary" className="form__button component__button" onClick={confirmEdit}>
              {t('admin.edit')}
            </Button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
};

export default EditAutoswapModal;